export enum CopyToSupplierExistingBehavior {
  Skip = "Skip",
  Overwrite = "Overwrite",
}
